/* prefer-destructuring */
const getUrlWithEnv = (url: string, mountPath: string): string => {
  let env = 'env';

  if (mountPath !== '' && mountPath?.includes('/sit')) {
    const mountpathArray = mountPath?.split('/');

    [, , env] = mountpathArray;

    return url?.replace('{{env}}', env);
  }
  return url?.replace('{{env}}/', '');
};

export default getUrlWithEnv;
